import { is } from 'ramda';
import { Utils } from '../Utils';
import { ApiUtils } from './api-util';

export abstract class ParamsAdapter {
  /**
   * Build params to send to API
   */
  build(): object | FormData {
    return this.toObject();
  }
  /**
   * @return object formatted as API requires
   */
  abstract getParams(): object;

  /**
   * Transform params to FormData
   */
  protected toFormData(): FormData {
    const params = this.getParams();

    return this.buildFormData(this.transform(params));
  }

  /**
   * Transform params to Object
   */
  protected toObject(): object {
    const params = this.getParams();
    const httpParams = this.transform(params);

    return httpParams;
  }

  private buildFormData(obj: any): FormData {
    const formData = new FormData();
    Object.keys(obj).forEach((key: string) => {
      // Array are stringify except for File[]
      if (obj[key] instanceof Array) {
        for (const file of obj[key]) {
          formData.append(key, file);
        }
      } else {
        formData.append(key, obj[key]);
      }
    });

    return formData;
  }

  private transform(obj: any): object {
    const params: any = {};

    Object.keys(obj)
      .filter(key => Utils.isNotNullAndNotUndefined(obj[key]))
      .forEach((key: string) => {
        let param = obj[key];
        if (is(Object, obj[key]) && obj[key].constructor === Object) {
          param = this.transform(obj[key]);
        }
        params[ApiUtils.toUnderscoreCase(key)] = ApiUtils.convert(param);
      });

    return params;
  }
}
